import { useTranslation } from "react-i18next";
import PartnerFooter from "../../components/PartnerFooter";
import ScreenHeader from "../../components/ScreenHeader";
import { HOME_CAROUSELS } from "./carouselTypes";
import ClubCarouselRow from "./ClubCarouselRow";
import HomeCategoryStrip from "./HomeCategoryStrip";
import HomePassBanner from "./HomePassBanner";
import HomeTopBar from "./HomeTopBar";
import useHomeData from "./useHomeData";
import "./home.scss";

// V2 home page, rendered at "/home" through the gate in screens/mainPage.jsx.
// No partner guard here — unlike the route-level V2 screens this one is only
// reachable through that gate, so a <Navigate to="/" /> would loop.
function Home() {
  const { t } = useTranslation();
  // The entry GPS attempt (refresh or permission prompt) lives in useHomeData —
  // its settled signal gates the carousel fetch.
  const {
    locationLabel,
    passState,
    showPrices,
    rows,
    allFailed,
    retry,
    priceForClub,
    defaultClubImg,
    imgFallbackSrc,
    passArt,
  } = useHomeData();

  return (
    <div className="hm-v2">
      {/* No back control — home is the root of the flow. */}
      <ScreenHeader title={t("HOME_TITLE")} variant="none" />
      <HomeTopBar locationLabel={locationLabel} />
      <HomeCategoryStrip />
      <HomePassBanner passState={passState} passArt={passArt} />

      {allFailed && (
        <div className="hm-v2-error">
          <p className="hm-v2-error-text">{t("HOME_CAROUSELS_ERROR")}</p>
          <button type="button" className="hm-v2-error-retry" onClick={retry}>
            {t("HOME_RETRY")}
          </button>
        </div>
      )}

      <div className="hm-v2-rows">
        {HOME_CAROUSELS.map(({ key, showPrice = true }) => (
          <ClubCarouselRow
            key={key}
            title={rows[key]?.name}
            row={rows[key]}
            priceForClub={priceForClub}
            showPrice={showPrice && showPrices}
            defaultClubImg={defaultClubImg}
            imgFallbackSrc={imgFallbackSrc}
          />
        ))}
      </div>

      <PartnerFooter />
    </div>
  );
}

export default Home;
